// src/Components/ProductCard/ProductCard.jsx

import React, { useEffect } from "react";
import { Grid, Box, Typography, Button } from "@mui/material";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import { styled } from "@mui/system";
import { Link } from "react-router-dom";

const StyledButton = styled(Button)(({ theme }) => ({
  backgroundColor: "#00AAE3",
  color: "#fff",
  fontWeight: "bold",
  marginTop: "30px",
  padding: "10px 30px",
  textTransform: "none",
  borderRadius: "30px",
  position: "relative",
  overflow: "hidden",
  transition: "background-color 0.3s ease",

  "&:hover": {
    backgroundColor: "#33BBE8",
  },

  "& .chevron-icon": {
    position: "absolute",
    right: "30px",
    opacity: 0,
    transition: "all 0.5s ease",
  },

  "&:hover .chevron-icon": {
    right: "0px",
    opacity: 1,
  },
}));

function ProductCard(props) {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        minHeight: { xs: "100vh", md: "auto" },
        pb: { md: 6 },
        backgroundColor: "#0f0f0f !important",
        color: "#fff",
        fontFamily: "Open Sans, Arial, sans-serif",
      }}
    >
      <Box sx={{ flex: 1, padding: 2, paddingTop: "20px" }}>
        <Box
          sx={{
            maxWidth: "1240px",
            width: { xs: "100%", sm: "82%" },
            margin: "0 auto",
          }}
        >
          <Grid container spacing={6} alignItems={props.cardImg2 ? "flex-start" : "center"}>
            <Grid item xs={12} md={6}>
              <Box sx={{ display: "flex", justifyContent: { xs: "center", md: "end" } }}>
                <Box
                  sx={{
                    width: { xs: "90%", md: "100%" },
                    mt: { xs: 9, md: 0 },
                  }}
                >
                  {props.cardImg2 ? (
                    <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
                      <Box sx={{ pb: "75%", position: "relative", overflow: "hidden" }}>
                        <Box
                          component="img"
                          src={props.cardImg}
                          alt="Product Image"
                          sx={{
                            position: "absolute",
                            top: 0,
                            left: 0,
                            width: "100%",
                            height: "100%",
                            objectFit: "cover",
                          }}
                        />
                      </Box>
                      <Box sx={{ pb: "75%", position: "relative", overflow: "hidden" }}>
                        <Box
                          component="img"
                          src={props.cardImg2}
                          alt="Product Image 2"
                          sx={{
                            position: "absolute",
                            top: 0,
                            left: 0,
                            width: "100%",
                            height: "100%",
                            objectFit: "cover",
                          }}
                        />
                      </Box>
                    </Box>
                  ) : (
                    <Box sx={{ pb: "75%", position: "relative", overflow: "hidden" }}>
                      <Box
                        component="img"
                        src={props.cardImg}
                        alt="Product Image"
                        sx={{
                          position: "absolute",
                          top: 0,
                          left: 0,
                          width: "100%",
                          height: "100%",
                          objectFit: "cover",
                        }}
                      />
                    </Box>
                  )}
                </Box>
              </Box>
            </Grid>

            <Grid item xs={12} md={6}>
              <Box sx={{ padding: 2, textAlign: { xs: 'center', md: 'left' } }}>
                {/* MODIFICATION: This logic now checks the type of the titleHead prop.
                  - If it's a STRING, it wraps it in the default Typography styling.
                  - If it's JSX (an object), it renders it directly.
                  This makes the component backward-compatible and safe for all pages.
                */}
                {typeof props.titleHead === "string" ? (
                  <Typography
                    variant="h2"
                    component="h2"
                    sx={{
                      fontWeight: "bold",
                      marginBottom: 2,
                      fontSize: "35px",
                      textTransform: "uppercase",
                      textAlign: { xs: 'center', md: 'left' },
                    }}
                  >
                    {props.titleHead}
                  </Typography>
                ) : (
                  props.titleHead
                )}

                <Typography
                  variant="h2"
                  component="h2"
                  sx={{ fontWeight: "bold", marginBottom: 2, fontSize: { xs: "18px", md: "20px" } }}
                >
                  {props.titleSubHead}
                </Typography>
                <Typography
                  variant="p"
                  component="p"
                  sx={{
                    fontWeight: "bold",
                    marginBottom: 2,
                    marginTop: 3,
                    fontSize: "16px",
                  }}
                >
                  {props.detailHead}
                </Typography>
                <Box sx={{ borderBottom: "1px solid #fff", marginTop: 4 }}></Box>
                <Typography
                  variant="body1"
                  sx={{
                    marginBottom: 2,
                    lineHeight: 1.6,
                    marginTop: 4,
                    fontSize: "16px",
                  }}
                >
                  {props.detailBody}
                </Typography>
                <Typography
                  variant="body1"
                  sx={{
                    marginBottom: 0,
                    lineHeight: 1.6,
                    marginTop: 0,
                    fontSize: "16px",
                  }}
                >
                  {props.detailBodyBr}
                </Typography>
                <Typography
                  variant="p"
                  component="p"
                  sx={{
                    fontWeight: "bold",
                    marginBottom: 2,
                    lineHeight: 1.6,
                    marginTop: 2,
                    fontSize: "16px",
                  }}
                >
                  {props.detailBody2}
                </Typography>
                <Typography
                  variant="p"
                  component="p"
                  sx={{ marginBottom: 2, marginTop: 2, fontSize: "16px" }}
                >
                  {props.detailBody3}
                </Typography>

                <Box sx={{ textAlign: { xs: "center", md: "left" } }}>
                  <Box sx={{ borderBottom: "1px solid #fff", marginTop: 4 }}></Box>
                  <Link to={props.btnLink}>
                    <StyledButton
                      sx={{
                        fontSize: { xs: "15px", sm: "15px", md: "16px" },
                        width: { xs: "100%", md: "auto" },
                        marginTop: "24px",
                      }}
                    >
                      {props.ProductCardBtn}
                      <ChevronRightIcon className="chevron-icon" />
                    </StyledButton>
                  </Link>
                </Box>
              </Box>
            </Grid>
          </Grid>
        </Box>
      </Box>
    </Box>
  );
}

export default ProductCard;